<ng-container *ngIf="_focus">
	<app-atom-loader></app-atom-loader>
</ng-container>
